import { render, staticRenderFns } from "./PopupMatchingRequest.vue?vue&type=template&id=6b0876d9&scoped=true"
import script from "./PopupMatchingRequest.vue?vue&type=script&lang=js"
export * from "./PopupMatchingRequest.vue?vue&type=script&lang=js"
import style0 from "./PopupMatchingRequest.vue?vue&type=style&index=0&id=6b0876d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0876d9",
  null
  
)

export default component.exports